export default {
  // 邮件
  email: {
    email: '邮件',
    refresh: '刷新',
    theme: '主题',
    sender: '发件人',
    time: '时间',
    addressee: '收件人',
    inbox: '收件箱',
    hasBeenSent: '已发送',
    drafts: '草稿箱',
    csPersonnel: '抄送人',
    emailContent: '邮件内容',
    themeIsMustfill: '主题是必填项',
    senderIsMustfill: '发件人是必填项',
    addresseeIsMustfill: '收件人是必填项',
    emailContentIsMustfill: '邮件内容是必填项',
    inputEmailAddress: '输入邮箱地址',
    rightEmailAddress: '请输入正确的邮箱地址',
    copyTo: '取消抄送',
    blindCarbonCopy: '密送',
    massTexting: '群发单显',
    write: '写信',
    enclosure: '附件',
    individual: '个',
    sendMail: '发邮件',
    recordContacts: '往来记录',
    mailList: '通讯录',
    deleted: '已删除',
    dustbin: '垃圾箱',
    label: '标签',
    mailSet: '邮件设置',
    bindTip: '请先将您的邮箱进行绑定，绑定后才可进行使用。',
    bindMyEmail: '绑定我的邮箱',
    messageSynchronizationSucceeded: '同步第三方邮件成功',
    classify: '分类',
    formName: '表单名称',
    permission: '访问权限',
    linkAddress: '链接地址',
    QRcodeSharing: '扫二维码，分享给好友',
    sigeCode: '签到二维码',
    downloadCode: '下载二维码',
    extendedLink: '扩展链接',
    formLinkTip: '对同一个表单赋予多个链接地址，用于标识不同数据提交来源。',
    personalTemplate: '个人模板',
    companyTemplate: '机构模板',
    allCustomerCategories: '所有客户分类',
    notFollowedUpInSevenDay: '七天未跟进',
    productionManage: '生产管理',
    mailTemplate: '邮件模板',
    dataTemplate: '数据模板',
    webLinkTemplate: 'WEB链接模版',
    copied: '已复制至剪切板',
    sign: '签到',
    pwdVisit: '密码访问',
    publicVisit: '公开访问',
    background: '背景',
    backgroundTip: '请选择设置背景',
    backgroundColor: '背景颜色',
    customColor: '自定义颜色',
    backgroundImage: '背景图片',
    clickUpdate: '点击上传',
    updateFileTip: '只能上传 jpg/png 文件,且不超过 500kb',
    pictureTile: '图片平铺',
    name: '姓名',
    mailAddress: '邮箱地址',
    addTime: '添加时间',
    selectOneData: '请选择一条数据',
    name_empty: '姓名不能为空',
    mailAddress_empty: '邮箱地址不能为空',
    mailAddress_error: '邮箱地址格式不正确',
    markedRead: '标记已读',
    unreadMark: '标记未读',
    urgentMail: '紧急邮件',
    regularMail: '定时邮件',
    draft: '草稿',
    partialSuccess: '部分成功',
    failInSend: '发送失败',
    approvalAdopt: '审批通过',
    approvalReject: '审批驳回',
    sendReadIsSend: '要求发送 "已读回执"，是否发送',
    send: '发送',
    noSend: '不发送',
    selectReminderTime: '选择提醒时间',
    remindYourselfOnly: '仅提醒自己',
    timingTransmission: '定时发送',
    preview: '预览',
    roughDraft: '存草稿',
    deleteThoroughly: '彻底删除',
    secretAgent: '密送人',
    addAttachments: '添加附件',
    addAttachmentFromFileLibrary: '从文件库中添加附件',
    insertMailTemplate: '插入邮件模版',
    insertModuleData: '插入模块数据',
    insertWebForm: '插入WEB表单',
    urgent: '紧急',
    receiptRequired: '需要回执',
    pureText: '纯文本',
    encryptMessage: '对邮件加密',
    useSignature: '使用签名',
    recentContacts: '最近联系人',
    selectContacts: '选择联系人',
    selectFromModules: '从模块中选择',
    selectFromAddressBook: '从通讯录中选择',
    modular: '模块',
    regularMailTip: '此邮件是定时邮件，将在',
    issue: '发出',
    yymmddhhmm: 'yyyy年 MM月 dd日 HH时 mm分',
    sendTime: '发送时间',
    editTime: '修改时间',
    EmailWillBeSentTo: '本邮件将在',
    sendToOppositeEmail: '发送到对方邮箱',
    selectAttachmentFromFileLibrary: '从文件库中选择附件',
    areYouSure: '你确定要',
    selectedMail: '选中的邮件吗？',
    mayPass: '可通过',
    backgroundCustomLayout: '后台-自定义模块-页面布局',
    add: '进行添加。',
    gotIt: '知道了',
    copySuccess: '复制成功',
    selectApprover: '选择审批人',
    nextStep: '下一环节',
    approver: '审批人',
    adopt: '通过',
    specifyNextApprover: '指定下一审批人',
    selectMembers: '选择成员',
    CC: '抄送',
    cancelSecretDelivery: '取消密送',
    cancelGroupReleaseSingleDisplay: '取消群发单显',
    mailboxFormatOutOfLimit: '邮箱格式超出限制',
    reply: '回复',
    wrote: '写道',
    forward: '转发',
    technologicalProcess: '流程',
    notSelectExpirationTime: '请不要选择已过期的时间',
    pleaseSelectContact: '请选择联系人',
    enterApprovalPhase: '您的邮件已进入审批环节，请在审批模块查看',
    successfulReply: '回复成功',
    forwardingSuccess: '转发成功',
    mailCont0ent_error: '邮件内容不能为空',
    theme_error: '主题不能为空',
    ddressee_empty: '收件人不能为空',
    sender_empty: '发件人不能为空',
    approver_empty: '审批人不能为空',
    chooseWhereAdd: '请选择需要添加的位置',
    mailboxDuplicate: '邮箱已重复',
    renturn: '返回',
    replyAll: '回复全部',
    withAccessories: '带附件',
    rejection: '拒收',
    moveTo: '移动到',
    rditSendAgain: '再次编辑发送',
    markedAs: '标记为',
    alreadRead: '已读',
    unread: '未读',
    markAllRead: '全部标记为已读',
    mailFrom: '发来的邮件',
    myMail: '我发送的邮件',
    seal: '封',
    sentMe: '发给我的',
    iSent: '我发送的',
    deleteTip: '你确定要彻底删除选中的邮件吗？',
    selectActionItem: '请选择需要进行操作的选项',
    noMessagesSelected: '未选中邮件',
    onlyOneDataSelected: '只能选择一条数据',
    exportMail: '导出选中邮件',
    altogether: '共',
    notSpam: '这不是垃圾邮件',
    addBusinessCardSignature: '添加名片签名',
    addTextSignature: '添加文本签名',
    signatureTitle: '签名标题',
    applicableAccount: '适用账号',
    founder: '创建人',
    default: '默认',
    defaultSignature: '默认签名',
    signatureTitle_empty: '签名标题不能为空',
    applicableAccount_empty: '适用账号不能为空',
    businessCardStyle: '名片样式',
    pleaseSelectAtLeastOneData: '请选择至少一条数据',
    dataSource: '数据源',
    templateName: '模版名称',
    private: '私密',
    public: '公开',
    modified: '修改人',
    template: '模板',
    type: '类型',
    updateTemplate: '上传模版',
    description: '描述',
    sampleTemplateDownLoad: '示例模版下载',
    templateDeleteTip: '你确定要删除该模板吗',
    customTemplateName: '自定义模版名称',
    salesManage: '销售管理',
    templateName_empty: '模板名称不能为空',
    tempCotent_empty: '模板内容不能为空',
    accountManage: '账号管理',
    disributionRule: '收信规则',
    signatureSet: '签名设置',
    blackAndWhileList: '黑白名单',
    labelSet: '标签设置',
    addRule: '添加规则',
    ruleName: '规则名称',
    ruleName_empty: '规则名称不能为空',
    enable: '状态',
    enable_empty: '状态不能为空',
    triggerEven: '触发事件',
    triggerCondition: '触发条件',
    performOperation: '执行操作',
    otherOperations: '其他操作',
    receiving: '接收 (临时存放在垃圾箱中)',
    reject: '拒绝 (直接删除)',
    moveTop: '移动至',
    autoReply: '自动回复',
    receivedMail: '收到邮件',
    contains: '包含',
    notIncluded: '不包含',
    EQUALS: '等于',
    NEQUALS: '不等于',
    GREATER: '大于',
    LESS: '小于',
    GREATERE: '大于等于',
    LESSE: '小于等于',
    mailSize: '邮件大小',
    editRule: '编辑规则',
    addLabel: '添加标签',
    editLabel: '编辑标签',
    labelName: '标签名称',
    labelName_empty: '标签名称不能为空',
    selectColor: '选择颜色',
    myName: '我的名字',
    onlyOneDataCanAdded: '每次只能添加一条数据',
    black: '黑名单',
    white: '白名单',
    as: '如',
    addWhite: '添加白名单',
    addBlack: '添加黑名单',
    115: '111111',
    inputTip: '请输入一个邮箱地址或域名后缀，添加后将拒收该地址来信。',
    inputTip2: '请输入一个邮箱地址或域名后缀。',
    editAccount: '编辑账号',
    toAuthorize: '前往授权',
    authorizeTip: '您当前要绑定的邮箱地址为',
    authorizeTip2: '，根据网易邮箱要求，在验证通过后请至',
    authorizeTip3: '进行授权，若不授权则可能会无法接收邮件',
    verifySuccess: '验证成功',
    cannotVerifyMultipleAccount: '不能同时验证多个账号',
    addAccount: '添加账号',
    verify: '验证',
    automaticCollectionTip: '新账号绑定后将自动收取最近三个月的邮件',
    OnlyIMAPProtocolSupported: '仅支持IMAP协议。邮局如果已有此功能，请勿勾选',
    authorizeTip4: '将邮局已发箱中的邮件同步到系统已发箱(仅支持IMAP协议)',
    synchronizationSentBoxes: '已发箱是否同步',
    sendSynchronization: '发件是否同步',
    encryptedTransmission: '加密传输',
    mustBeEmailAddress: '必须为邮箱地址',
    authorization: '授权码',
    authorization_empty: '授权码不能为空',
    setAuthorization: '请在邮箱设置中获取服务授权码',
    authorizeTip5: '请在邮箱中开启POP3/SMTP获取授权码，在',
    set: '【设置】',
    account: '【帐户】',
    servers: '【POP3/SMTP...服务】',
    getAuthorization: '中开启服务，获取授权码',
    nickname: '昵称',
    receivingServerType: '接收服务器类型',
    receivingServerType_empty: '接收服务器类型不能为空',
    receivingServer: '收件服务器',
    receivingServer_empty: '收件服务器类型不能为空',
    port: '端口',
    port_empty: '端口不能为空',
    outgoingServer: '发件服务器',
    outgoingServer_empty: '发件服务器不能为空',
    synchronizationSentboxes: '已发箱是否同步',
    introduction: '打通第三方邮件功能，收发邮件不再来回切换查看',
    mailQuery: '数据查询',
    mailProcess: '流程管理',
    1111: '保存并使用',
    1112: '重置',
    1113: '撤销',
    nodeAttribute: '节点属性',
    nodeAttribute_empty: '请选择节点',
    nodeName: '节点名称',
    nodeNameNaxLength15: '只能输入15个字符',
    branchCondition: '分支条件',
    setBranchCondition: '设置分支条件',
    terminationApprover: '终止审批人',
    approverTip: '只要终止审批人审批过后，审批单就不再继续往上流转、终止审批人可以多选。',
    approvalWay: '审批方式',
    approvalTurn: '依次审批',
    onceApproval: '（本环节内审批人一次审批）',
    jointlySign: '会签',
    jointlySignTip: '（所有审批人同时收到审批，且所有人需同意方可算审批通过）',
    orSign: '或签',
    orSignTip: '（所有审批人同时收到审批，只需一个人审批通过或拒绝即可）',
    originator: '发起人的',
    throughMethod: '通过方式',
    thereIsDraftBox: '存在草稿箱,由发件人手动发送',
    directToCustomer: '直接发送给客户',
    over: '结束',
    start: '开始',
    dragAddNewNode: '拖拽添加新节点',
    saving: '保存中...',
    mailData: '邮件数据',
    deleteTip2: '此操作将永久删除邮件, 是否继续?',
    receipt: '收件',
    hairParts: '发件',
    templatePermission: '模版权限',
    templatePermissionNote: '用于控制邮件设置中机构模版和数据模版的新增、编辑和删除权限。',
    templateManage: '模板管理员',
    addManage: '添加管理员',
    synchronization: '同步',
    synchronizationtimesetting: '同步时间设置',
    selectfromorganizationalstructure: '从组织架构中选择',
    synchronizationtimesettingTip: '新邮件信息同步时间设置，每',
    synchronizationtimesettingTip2: '次。系统自动去第三方拉去新邮件信息。',
    synchronousOption1: '实时',
    synchronousOption2: '1个小时',
    synchronousOption3: '无，按系统固定规则拉取',
    newmailshare: '新建邮件共享',
    mailshareTip:
      '通过该功能设定指定的人员可以查看某些成员的邮件往来。比如经理查看下级成员的邮件往来，总监可以查看所有人员的邮件往来。',
    sharesetting: '共享设置',
    closepreview: '关闭该预览',
    tentatively: '暂定者',
    scheduleoverdue: '日程已过期',
    // 20210526
    bindemailremark:
      '系统公用发件邮箱，用于消息推送、工作流自动化、审批流程和业务流程中发送邮件作为发件人使用，公用邮箱通常有客服邮箱、业务邮箱、人事邮箱等。',
    emailAddress: '邮件地址',
    bindEmail: '绑定邮箱',
    name_empty2: '名称不能为空',
    port_error: '端口格式不正确',
    delAddressTip: '确定要删除该邮件地址吗？'
  }
}
